// Runtime asset locations for pdf.js (as used by @tato30/vue-pdf), served
// same-origin by the `pdfjsAssets` plugin in vite.config.ts. Spread into every
// `usePDF` call: without `wasmUrl`, JBIG2/JPX images (common in scans) fail to
// decode and pages render incomplete.
//
// The URLs must be absolute: pdf.js hands them to its worker, which runs from
// a `data:` URL and can't resolve relative paths.
const base = new URL(`${import.meta.env.BASE_URL}pdfjs/`, window.location.href).href;

export const pdfjsAssetOptions = {
  wasmUrl: `${base}wasm/`,
  cMapUrl: `${base}cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `${base}standard_fonts/`,
  iccUrl: `${base}iccs/`,
};
